import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useApp } from '../App';
import { requireRole } from '../utils/roles';
import { UserRoles, positionLabel } from '../utils/constants';

export default function MemberPanel() {
  const { currentTeam, isAdmin, roles } = useApp();
  const canEdit = isAdmin;   // 역할 변경 = 소유자·운영자만 (규칙 115: 코치는 adminIds 변경 거부)
  const [members, setMembers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [roleFilter, setRoleFilter] = useState('all');

  useEffect(() => { if (currentTeam) loadMembers(); }, [currentTeam]);
  const loadMembers = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db,'teams',currentTeam.id,'members'));
      const list = [];
      for (const md of snap.docs) {
        const mData = md.data(); let uProfile = {};
        try { const ud = await getDoc(doc(db,'users',md.id)); if(ud.exists()) uProfile=ud.data(); } catch{}
        list.push({ id:md.id, ...mData, ...uProfile, uid:md.id, role:mData.role||'member' });
      }
      setMembers(list);
    } catch(err){console.error(err);}
    setLoading(false);
  };

  const handleRole = async (mid, newRole) => {
    if (!requireRole(roles, 'isAdmin')) return;
    try { await updateDoc(doc(db,'teams',currentTeam.id,'members',mid),{role:newRole}); setMembers(p=>p.map(m=>m.id===mid?{...m,role:newRole}:m)); if(selected?.id===mid) setSelected(p=>({...p,role:newRole})); } catch(err){alert('역할 변경 실패');}
  };

  const filtered = roleFilter==='all'?members:members.filter(m=>m.role===roleFilter);
  const rc = { all:members.length, coach:members.filter(m=>m.role==='coach').length, admin:members.filter(m=>m.role==='admin').length, member:members.filter(m=>m.role==='member').length };

  return (
    <div style={{ display:'grid', gridTemplateColumns:'1fr 360px', gap:24, maxWidth:1100 }}>
      <div style={s.panel}>
        <div style={{...s.ph,display:'flex',justifyContent:'space-between',alignItems:'center'}}><h2 style={s.pt}>👥 멤버 관리</h2><span style={{fontSize:12,color:'#778899'}}>{members.length}명</span></div>
        <div style={{padding:'8px 16px',display:'flex',gap:6,borderBottom:'1px solid rgba(91,196,216,0.04)'}}>
          {[['all','전체'],['coach','코치'],['admin','운영진'],['member','멤버']].map(([k,l])=>(
            <button key={k} onClick={()=>setRoleFilter(k)} style={{padding:'4px 10px',borderRadius:6,border:'none',fontSize:11,cursor:'pointer',fontWeight:600,backgroundColor:roleFilter===k?'rgba(91,196,216,0.15)':'transparent',color:roleFilter===k?'#5BC4D8':'#667788'}}>{l} ({rc[k]||0})</button>
          ))}
        </div>
        <div style={s.pb}>
          {loading?<div style={s.empty}>로딩 중...</div>:filtered.length===0?<div style={s.empty}>멤버가 없습니다</div>:
            filtered.map(m=>{const ri=UserRoles[m.role]||UserRoles.member; return (
              <div key={m.id} onClick={()=>setSelected(m)} style={{padding:'12px 14px',marginBottom:4,borderRadius:8,cursor:'pointer',backgroundColor:selected?.id===m.id?'rgba(91,196,216,0.08)':'transparent',display:'flex',alignItems:'center',gap:12}}>
                <div style={s.av}>{(m.name||'?')[0].toUpperCase()}</div>
                <div style={{flex:1}}><div style={{fontWeight:600,fontSize:14}}>{m.name||m.id.substring(0,8)}</div><div style={{fontSize:12,color:'#778899'}}>{positionLabel(m.position, m.positions)}{m.jerseyNumber?' #'+m.jerseyNumber:''}</div></div>
                <span style={{fontSize:10,padding:'3px 10px',borderRadius:10,border:'1px solid '+ri.color,color:ri.color,fontWeight:600}}>{ri.icon} {ri.label}</span>
              </div>);
            })}
        </div>
      </div>
      <div style={s.panel}>
        <div style={s.ph}><h2 style={s.pt}>📋 멤버 정보</h2></div>
        <div style={{padding:16}}>
          {selected?(
            <>
              <div style={{textAlign:'center',marginBottom:20}}>
                <div style={{...s.av,width:56,height:56,fontSize:22,margin:'0 auto 8px'}}>{(selected.name||'?')[0].toUpperCase()}</div>
                <div style={{fontSize:18,fontWeight:700}}>{selected.name||selected.id?.substring(0,8)||'Unknown'}</div>
              </div>
              <div style={{display:'grid',gap:10,marginBottom:20}}>
                <IB label="역할" value={(UserRoles[selected.role]||{}).label||selected.role} />
                {selected.position&&<IB label="포지션" value={positionLabel(selected.position, selected.positions)} />}
                {selected.jerseyNumber&&<IB label="등번호" value={'#'+selected.jerseyNumber} />}
                {selected.shootingSide&&<IB label="슈팅" value={selected.shootingSide==='left'?'좌타':'우타'} />}
                {selected.joinedAt&&<IB label="가입일" value={selected.joinedAt?.toDate?selected.joinedAt.toDate().toLocaleDateString('ko-KR'):''} />}
              </div>
              {canEdit&&<div><div style={{fontSize:12,color:'#667788',fontWeight:600,marginBottom:8}}>역할 변경</div><div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                {Object.entries(UserRoles).filter(([k])=>k!=='guest'&&k!=='parent').map(([k,v])=>(
                  <button key={k} onClick={()=>handleRole(selected.id,k)} style={{padding:'6px 14px',borderRadius:8,border:'none',fontSize:12,cursor:'pointer',fontWeight:600,backgroundColor:selected.role===k?v.color+'20':'rgba(255,255,255,0.03)',color:selected.role===k?v.color:'#778899'}}>{v.icon} {v.label}</button>
                ))}
              </div></div>}
            </>
          ):<div style={s.empty}><div style={{fontSize:36,opacity:0.5}}>👈</div>멤버 선택</div>}
        </div>
      </div>
    </div>
  );
}
function IB({label,value}){return(<div style={{padding:10,borderRadius:8,backgroundColor:'rgba(255,255,255,0.02)'}}><div style={{fontSize:11,color:'#667788',marginBottom:2}}>{label}</div><div style={{fontSize:13,fontWeight:500}}>{value}</div></div>);}
const s={panel:{backgroundColor:'rgba(255,255,255,0.02)',border:'1px solid rgba(91,196,216,0.06)',borderRadius:12,overflow:'hidden'},ph:{padding:'14px 20px',borderBottom:'1px solid rgba(91,196,216,0.06)'},pt:{margin:0,fontSize:15,fontWeight:600},pb:{padding:12,maxHeight:'calc(100vh - 200px)',overflowY:'auto'},empty:{textAlign:'center',padding:'50px 20px',color:'#556677',fontSize:14},av:{width:34,height:34,borderRadius:'50%',backgroundColor:'rgba(91,196,216,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:600,color:'#5BC4D8'}};
